import { Role } from 'app/enums';

export type User = {
    id: string;
    firstName: string;
    lastName: string;
    title?: string;
    phone?: string;
    customerId?: string;
    customerName?: string;
    email: string;
    inboxEmail?: string;
    roles: Role[];
    numberOfAgreements?: number;
    isDeletable: boolean;
};
